import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from "@ctms/api.service";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgbNavModule} from "@ng-bootstrap/ng-bootstrap";
import {Paginator} from "@shared/components/paginator/paginator.component";
import {PatientRecordRisksService} from "@shared/api/services/v2/patient-record-risks.service";
import {PatientRecordRisk} from "@shared/api/models/query/patient-record-risk.model";
import {PatientRecordRiskUpdate} from "@shared/api/models/command/patient-record-risk.model";


@Component({
    selector: 'cdss-patient-records-risk',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, NgbNavModule],
    providers: [ApiService],
    standalone: true,
    templateUrl: './patient-records-risk.component.html'
})
export class PatientRecordsRiskComponent extends Paginator {

    editing: boolean = false
    editingId?: number = null
    @Input() patientId: number

    form: FormGroup

    constructor(
        private toastr: ToastrService,
        service: PatientRecordRisksService
    ) {
        super()
        this.service = service
    }

    ngOnInit(): void {
        this.filterForm = new FormGroup({
        });
        this.form = new FormGroup({
            physicalRiskLevel: new FormControl(),
            moodRiskLevel: new FormControl(),
            selfHarmSuicideRiskLevel: new FormControl(),
            isSafeguardingActionTaken: new FormControl(),
            safeguardingActionDetails: new FormControl(),
            notesOnIdentifiedRisk: new FormControl(),
        }, {
            validators: [
                (control) => {
                    control.get("physicalRiskLevel").setErrors(null)
                    control.get("moodRiskLevel").setErrors(null)
                    control.get("selfHarmSuicideRiskLevel").setErrors(null)
                    if (control.get("physicalRiskLevel").value == null && control.get("moodRiskLevel").value == null && control.get("selfHarmSuicideRiskLevel").value == null) {
                        control.get("physicalRiskLevel").setErrors({...(control.errors || {}), match: "Required"})
                        control.get("moodRiskLevel").setErrors({...(control.errors || {}), match: "Required"})
                        control.get("selfHarmSuicideRiskLevel").setErrors({...(control.errors || {}), match: "Required"})
                    }
                    return null
                }
            ]
        })
        this.form.get('isSafeguardingActionTaken')?.valueChanges.subscribe(isSafeguardingActionTaken => {
            if (!isSafeguardingActionTaken) {
                this.form.get('safeguardingActionDetails')?.reset();
            }
        });

        this.service.setParent(this.patientId)
        this.refreshRows()
    }

    edit(row: PatientRecordRisk) {
        this.editingId = row.id
        const data = {
            physicalRiskLevel: row.physicalRiskLevel,
            moodRiskLevel: row.moodRiskLevel,
            selfHarmSuicideRiskLevel: row.selfHarmSuicideRiskLevel,
            isSafeguardingActionTaken: row.isSafeguardingActionTaken,
            safeguardingActionDetails: row.safeguardingActionDetails,
            notesOnIdentifiedRisk: row.notesOnIdentifiedRisk,
        }
        this.form.patchValue(data)
        this.editing = true
    }

    add() {
        this.editingId = null
        this.form.reset()
        this.editing = true
    }

    cancel() {
        this.editing = false
    }

    submit() {
        if (this.form.valid) {
            this.loading = true
            const value: PatientRecordRiskUpdate = {
                physicalRiskLevel: this.form.value.physicalRiskLevel,
                moodRiskLevel: this.form.value.moodRiskLevel,
                selfHarmSuicideRiskLevel: this.form.value.selfHarmSuicideRiskLevel,
                isSafeguardingActionTaken: this.form.value.isSafeguardingActionTaken,
                safeguardingActionDetails: this.form.value.safeguardingActionDetails,
                notesOnIdentifiedRisk: this.form.value.notesOnIdentifiedRisk,
            }
            if (this.editingId == null) {
                this.service.create(value).subscribe({
                    next: () => {
                        this.refreshRows()
                        this.toastr.success('Risk record successfully created', 'Success');
                        this.editing = false
                        this.loading = false
                    }
                })
            } else {
                this.service.update(this.editingId, value).subscribe({
                    next: () => {
                        this.refreshRows()
                        this.toastr.success('Risk record successfully updated', 'Success');
                        this.editing = false
                        this.loading = false
                    }
                })
            }
        } else {
            this.form.markAllAsTouched()
            this.toastr.error('Please fill all the required fields');
        }
    }
}
